// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { Chapter, Note, Progress } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

interface WorkshopContentState {
  workshopContents: { [key: string]: Chapter[] };
  workshopProgress: { [key: string]: Progress[] };
  workshopNotes: { [key: string]: Note[] };
  isLoading: boolean;
  isNotesLoading: boolean;
  isCreateNoteLoading: boolean;
  isDeleteNoteLoading: boolean;
  isUpdateNoteLoading: boolean;
  isUpdateProgressLoading: boolean;
  error?: Error;
  noteError?: Error;
  progressError?: Error;
}

const {
  getWorkshopContentsDataActions,
  getWorkshopNotesDataActions,
  createWorkshopNoteActions,
  updateWorkshopNoteActions,
  updateWorkshopProgressActions,
  deleteWorkshopNoteActions
} = actionCreatorsList;

export const initialState: WorkshopContentState = {
  workshopContents: {},
  workshopNotes: {},
  workshopProgress: {},
  isLoading: true,
  isNotesLoading: true,
  isCreateNoteLoading: false,
  isDeleteNoteLoading: false,
  isUpdateNoteLoading: false,
  isUpdateProgressLoading: false
};

const workshopContentsDataReducer = (state = initialState, action: RootAction):WorkshopContentState => {
  switch (action.type) {
    case getType(getWorkshopContentsDataActions.request): {
      const { preventLoading = false } = action.payload;
      return {
        ...state,
        isLoading: !preventLoading,
        error: undefined
      };
    }
    case getType(getWorkshopContentsDataActions.success): {
      const { payload } = action;
      const {
        id,
        chapters,
        progress,
      } = payload;

      return {
        ...state,
        isLoading: false,
        workshopContents: { [id]: chapters },
        workshopProgress: { [id]: progress },
      };
    }
    case getType(getWorkshopContentsDataActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    case getType(getWorkshopNotesDataActions.request): {
      return {
        ...state,
        isNotesLoading: true,
        noteError: undefined
      };
    }
    case getType(getWorkshopNotesDataActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isNotesLoading: false,
        workshopNotes: { [id]: notes },
      };
    }
    case getType(getWorkshopNotesDataActions.failure): {
      return {
        ...state,
        isNotesLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(createWorkshopNoteActions.request): {
      return {
        ...state,
        isCreateNoteLoading: true,
        noteError: undefined
      };
    }
    case getType(createWorkshopNoteActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isCreateNoteLoading: false,
        workshopNotes: { [id]: notes },
      };
    }
    case getType(createWorkshopNoteActions.failure): {
      return {
        ...state,
        isCreateNoteLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(updateWorkshopNoteActions.request): {
      return {
        ...state,
        isUpdateNoteLoading: true,
        noteError: undefined
      };
    }
    case getType(updateWorkshopNoteActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isUpdateNoteLoading: false,
        workshopNotes: { [id]: notes },
      };
    }
    case getType(updateWorkshopNoteActions.failure): {
      return {
        ...state,
        isUpdateNoteLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(deleteWorkshopNoteActions.request): {
      return {
        ...state,
        isDeleteNoteLoading: true,
        noteError: undefined
      };
    }
    case getType(deleteWorkshopNoteActions.success): {
      const {
        id,
        notes
      } = action.payload;

      return {
        ...state,
        isDeleteNoteLoading: false,
        workshopNotes: { [id]: notes },
      };
    }
    case getType(deleteWorkshopNoteActions.failure): {
      return {
        ...state,
        isDeleteNoteLoading: false,
        noteError: action.payload.error
      };
    }
    case getType(updateWorkshopProgressActions.request): {
      return {
        ...state,
        isUpdateProgressLoading: true,
        progressError: undefined
      };
    }
    case getType(updateWorkshopProgressActions.success): {
      const {
        id,
        progress
      } = action.payload;

      return {
        ...state,
        isUpdateProgressLoading: false,
        workshopProgress: { [id]: progress },
      };
    }
    case getType(updateWorkshopProgressActions.failure): {
      return {
        ...state,
        isUpdateProgressLoading: false,
        progressError: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export {workshopContentsDataReducer as default};
